import React, { useState } from "react";
import { Form, useActionData } from "react-router-dom";
import Button from "../ui/buttons/Button";
import SmallAlert from "../ui/alerts/SmallAlert";

function ResendActivationForm({ token }) {
  const data = useActionData();
  const [sent, setSent] = useState(false);

  // disable once they've submitted or once we have a response
  const disabled = sent || Boolean(data);

  return (
    <Form method="post" onSubmit={() => setSent(true)} className="resend-form">
      <input type="hidden" name="token" value={token} />
      {data?.error && (
        <div className="resend-alert-wide">
          <SmallAlert alert="True" type="error" message={data.error} />
        </div>
      )}
      {data?.success && (
        <div className="resend-alert-wide">
          <SmallAlert
            alert="True"
            type="success"
            message={"We’ve sent another activation email to your email."}
          />
        </div>
      )}
      <Button
        text="Resend activation email"
        disabled={disabled}
        fullWidth={false}
        className="resend-button"
      />
    </Form>
  );
}

export default ResendActivationForm;
